export const projectsData = [
    {
      id: 1,
      title: "BINGO",
      description: "A game developed in JAVA implementing the classic Bingo game with interactive features.",
      image: "/projects/project3.jpg",
      technologies: ["Game", "Java"],
      codeUrl: "https://github.com/aaryaa28/BINGO",
      downloadLink: "https://github.com/aaryaa28/Portfolio-Download",
      // note: "add notes here if you want to show it near the download link",
      featured: false,
      tags: ["game", "java"],
      year: "2023"
    },
    {
      id: 2,
      title: "DataDash Website",
      description: "A website for the DataDash application, providing information and download resources for users.",
      image: "/projects/datadash.png",
      technologies: ["Website", "Next.js", "Tailwind CSS"],
      codeUrl: "https://github.com/Armaan4477/DataDash-Website",
      demoUrl: "https://datadash.is-a.dev/",
      featured: true,
      tags: ["website"],
      year: "2025"
    },
    {
      id: 3,
      title: "KCCEMSR EVENTS",
      description: "A college events website for managing and promoting various events happening at KCCEMSR.",
      image: "/projects/project2.png",
      technologies: ["Events", "Management", "Website"],
      codeUrl: "https://github.com/aaryaa28/kccemsrevents",
      downloadLink: "https://github.com/aaryaa28/Portfolio-Download",
      // note: "add notes here if you want to show it near the download link",
      featured: false,
      tags: ["website", "management"],
      year: "2023"
    },
    {
      id: 4,
      title: "Portfolio Website",
      description: "A modern, responsive portfolio website built with Next.js and Tailwind CSS showcasing projects, skills, and professional information. Features include dark/light mode with system preference detection, interactive UI with smooth animations using Framer Motion, filterable project showcase, and GitHub contribution visualization.",
      image: "/projects/portfolio.png",
      technologies: ["Website","Next.js", "Tailwind CSS"],
      codeUrl: "https://github.com/aaryaa28/Portfolio-nextjs",
      demoUrl: "https://aaryaa28.is-a.dev",
      featured: false,
      tags: ["website"],
      year: "2025"
    },
    {
      id: 5,
      title: "Study Zone",
      description: "A study guidance website that helps students find resources and guidance for their academic needs.",
      image: "/projects/pro1.png",
      technologies: ["Website", "Education"],
      codeUrl: "https://github.com/NinadWalke/Study-Website",
      downloadLink: "https://github.com/aaryaa28/Portfolio-Download",
      // note: "add notes here if you want to show it near the download link",
      featured: true,
      tags: ["website", "education"],
      year: "2024"
    }
  ];

export const getFeaturedProjects = () => {
  return projectsData.filter(project => project.featured);
};
